<h2 mat-dialog-title>{{dialogData.key}}</h2>

<mat-dialog-content>
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto custom-width w-100" id="section" >
      <form [formGroup]="dialogForm" class="m-1">

        <div class="input-group" >
          <mat-form-field appearance="outline" class="w-100" >
            <mat-label>{{'content.type' | translate}} </mat-label>
            <mat-select formControlName="type" class="input-group m-1">
              <mat-option value="string">{{'content.text' | translate}} </mat-option>
              <mat-option value="number">{{'content.number' | translate}} </mat-option>
              <mat-option value="boolean">{{'content.bool' | translate}} </mat-option>
              <mat-option value="array">{{'content.list' | translate}} </mat-option>
              <mat-option value="object">{{'content.keyValue' | translate}} </mat-option>
              <mat-option value="date">{{'content.date' | translate}} </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'content.key' | translate}}</mat-label>
          <input formControlName="key" type="text" matInput placeholder="Key">
        </mat-form-field>

        @if (type=='string') {
          <div>
            @if (type=='string') {
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'content.value' | translate}}</mat-label>
                <textarea matInput formControlName="value" class="form-control" placeholder="{{'content.value' | translate}}" id="value" rows="5"></textarea>
              </mat-form-field>
            }
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> {{'content.translations' | translate}}</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex justify-content-start pb-4">
                <button class="secondary-gray-button" mat-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                  <mat-icon>add</mat-icon> {{'add' | translate}}
                </button>
                <mat-menu #menu="matMenu">
                  @for (lang of availableLangList; track lang) {
                    <button mat-menu-item
                      (click)="addTranslation(lang.key)">
                      {{ lang.value }}
                    </button>
                  }
                </mat-menu>
              </div>
              <div class="w-100">
                <mat-accordion>
                  <div formArrayName="values">
                    @for (control of valuesArray.controls; track control; let index = $index) {
                      <mat-expansion-panel [formGroupName]="index">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{languagesList[control.get('lang')?.value] || control.get('lang')?.value}}
                          </mat-panel-title>
                          <mat-panel-description>
                            <button mat-icon-button style="color:var(--warmOrange);" (click)="deleteValue(index)">
                              <mat-icon>delete</mat-icon>
                            </button>
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>{{'content.value' | translate}}</mat-label>
                          <textarea matInput formControlName="value" class="form-control"
                          placeholder="{{'content.value' | translate}}" rows="5"></textarea>
                        </mat-form-field>
                      </mat-expansion-panel>
                    }
                  </div>
                </mat-accordion>
              </div>
            </mat-expansion-panel>
          </div>
        }

        @if (type=='number') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'content.value' | translate}}</mat-label>
            <input matInput formControlName="value" class="form-control" placeholder="{{'content.value' | translate}}" id="value" type="number" >
          </mat-form-field>
        }

        @if (type=='boolean') {
          <div class="form-control mb-1 d-flex justify-content-between">
            <label for="value">{{'content.value' | translate}}</label>
            <mat-slide-toggle class="example-margin" formControlName="value" ></mat-slide-toggle>
          </div>
        }

        @if (type=='array') {
          <div class="form-group m-1">
            <div class="d-flex flex-row justify-content-between align-items-center">
              <label for="value">{{'content.LIST' | translate}}</label>
            </div>
            <button mat-button
              [matMenuTriggerFor]="newContentValue"
              [disabled]="!contentUserRights_update"
              class="secondary-gray-button mb-3 mt-2"
              id="btn-add"
              >
              <mat-icon>add_circle</mat-icon> {{'add' | translate}}
            </button>
            <mat-menu #newContentValue="matMenu">
              <button mat-menu-item (click)="addNewValue('text');" [disabled]="currentType && currentType !== 'text'">
                <div class="d-flex">
                  <span class="material-symbols-outlined pe-2">
                    font_download
                  </span>
                  <span>{{'content.text' | translate}}</span>
                </div>
              </button>
              <button mat-menu-item (click)="addNewValue('number');" [disabled]="currentType && currentType !== 'number'">
                <div class="d-flex">
                  <span class="material-symbols-outlined pe-2">
                    tag
                  </span>
                  <span>{{'content.number'  | translate}}</span>
                </div>
              </button>
              <button mat-menu-item (click)="addNewValue('boolean');" [disabled]="currentType && currentType !== 'boolean'">
                <div class="d-flex">
                  <span class="material-symbols-outlined pe-2">
                    toggle_on
                  </span>
                  <span>{{'content.bool' | translate}}</span>
                </div>
              </button>
              <button mat-menu-item (click)="addNewValue('date');" [disabled]="currentType && currentType !== 'date'">
                <div class="d-flex">
                  <span class="material-symbols-outlined pe-2">
                    calendar_month
                  </span>
                  <span>{{'content.date' | translate}}</span>
                </div>
              </button>
            </mat-menu>
            <div class="list-group">
              @for (value of dialogForm.value.value; track value; let index = $index) {
                <div class="d-flex flex-row justify-content-between align-items-center border-bottom list-group-item" id="item-list">
                  @if (isNumber(value)) {
                    <div class="flex-grow-1">
                      <span class="text-break">{{value}}</span>
                    </div>
                  }
                  @if (isString(value)) {
                    <div class="flex-grow-1">
                      <span class="text-break">{{value}}</span>
                    </div>
                  }
                  @if (isBoolean(value)) {
                    <div class="flex-grow-1">
                      <mat-slide-toggle class="example-margin" [checked]="value"  class=" mb-1" disabled> </mat-slide-toggle>
                    </div>
                  }
                  @if (isObject(value)) {
                    <div class="flex-grow-1">
                      @if (value.nanoseconds || value.seconds) {
                        <div>
                          <span class="text-break">{{isDateTime(value)}}</span>
                        </div>
                      }
                      @if (!value.nanoseconds && !value.seconds) {
                        <div>
                          @if (value.key) {
                            <div>____
                              <span class="text-break">{{value.key}}</span>
                            </div>
                          }
                          @if (!value.key) {
                            <span class="text-break">{{value}}</span>
                          }
                        </div>
                      }
                    </div>
                  }
                  <div class="ps-1 border-start d-flex flex-row flex-nowrap">
                    @if (contentUserRights_update) {
                      <button mat-icon-button (click)="editListValue(value, index);">
                        <span class="material-symbols-outlined" style="color: var(--warmOrange);">
                          edit
                        </span>
                      </button>
                    }
                    @if (!contentUserRights_update) {
                      <button mat-icon-button (click)="editListValue(value, index);" disabled>
                        <span class="material-symbols-outlined" >
                          edit
                        </span>
                      </button>
                    }
                    @if (contentUserRights_update) {
                      <button mat-icon-button (click)="deleteListValue(value, index);">
                        <span class="material-symbols-outlined" style="color: red;">
                          delete
                        </span>
                      </button>
                    }
                    @if (!contentUserRights_update) {
                      <button mat-icon-button (click)="deleteListValue(value, index);" disabled>
                        <span class="material-symbols-outlined" >
                          delete
                        </span>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        @if (type=='object') {
          <div class="form-group m-1">
            <div class="d-flex flex-row justify-content-between align-items-center">
              <label for="value">{{'content.keyValue' | translate}}</label>
            </div>
            <button mat-button
              [matMenuTriggerFor]="newContentValue"
              [disabled]="!contentUserRights_update"
              class="secondary-gray-button mb-3 mt-2"
              id="btn-add"
              >
              <mat-icon>add_circle</mat-icon> {{'add' | translate}}
            </button>
            <mat-menu #newContentValue="matMenu">
              <button mat-menu-item (click)="addNewValue('text');">
                <div class="d-flex">
                  <span class="material-symbols-outlined pe-2">
                    font_download
                  </span>
                  <span>{{'content.text' | translate}}</span>
                </div>
              </button>
              <button mat-menu-item (click)="addNewValue('number');">
                <div class="d-flex">
                  <span class="material-symbols-outlined pe-2">
                    tag
                  </span>
                  <span>{{'content.number' | translate}}</span>
                </div>
              </button>
              <button mat-menu-item (click)="addNewValue('boolean');">
                <div class="d-flex">
                  <span class="material-symbols-outlined pe-2">
                    toggle_on
                  </span>
                  <span>{{'content.bool' | translate}}</span>
                </div>
              </button>
              <button mat-menu-item (click)="addNewValue('date');">
                <div class="d-flex">
                  <span class="material-symbols-outlined pe-2">
                    calendar_month
                  </span>
                  <span>{{'content.date' | translate}}</span>
                </div>
              </button>
            </mat-menu>
            <div class="list-group">
              @for (value of dataValues; track value; let index = $index) {
                <div class="d-flex flex-row justify-content-between align-items-center border-bottom list-group-item" id="item-list">
                  @if (isNumber(value)) {
                    <div class="flex-grow-1">
                      <span class="text-break">{{value}}</span>
                    </div>
                  }
                  @if (isString(value)) {
                    <div class="flex-grow-1">
                      <span class="text-break">{{value}}</span>
                    </div>
                  }
                  @if (isBoolean(value)) {
                    <div class="flex-grow-1">
                      <mat-slide-toggle class="example-margin" [checked]="value"  class="mb-1" disabled> </mat-slide-toggle>
                    </div>
                  }
                  @if (isObject(value)) {
                    <div class="flex-grow-1 pe-2">
                      <!-- <div *ngIf="value.nanoseconds || value.seconds">
                      <span class="text-break">{{value?.toDate() | date}}</span>
                    </div>
                    <div *ngIf="!value.nanoseconds && !value.seconds">
                      <span class="text-break">{{value}}</span>
                    </div> -->
                    <div>
                      <span class="text-break text-wrap">{{isDateTime(value)}}</span>
                    </div>
                  </div>
                }
                <div class="ps-1 border-start d-flex flex-row flex-nowrap">
                  @if (contentUserRights_update) {
                    <button mat-icon-button (click)="editListValue(value, index);">
                      <span class="material-symbols-outlined" style="color: var(--warmOrange);">
                        edit
                      </span>
                    </button>
                  }
                  @if (!contentUserRights_update) {
                    <button mat-icon-button (click)="editListValue(value, index);" disabled>
                      <span class="material-symbols-outlined" >
                        edit
                      </span>
                    </button>
                  }
                  @if (contentUserRights_update) {
                    <button mat-icon-button (click)="deleteListValue(value, index);">
                      <span class="material-symbols-outlined" style="color: red;">
                        delete
                      </span>
                    </button>
                  }
                  @if (!contentUserRights_update) {
                    <button mat-icon-button (click)="deleteListValue(value, index);" disabled >
                      <span class="material-symbols-outlined" >
                        delete
                      </span>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- <div *ngIf="type=='date'" class="form-group m-1">
      <label for="value">{{'content.value' | translate}}</label>
      <input matInput  class="form-control" placeholder="Value" id="value" type="date" formControlName="date">
      <input matInput  class="form-control mt-1" placeholder="Value" id="value" type="time" formControlName="time">
    </div> -->
    @if (type=='date') {
      <div class="pt-2">
        <mat-form-field appearance="outline">
          <mat-label> {{'content.date' | translate}}</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="date" placeholder="{{'dd.mm.yyyy' | translate}}"  readonly>
          <mat-hint>{{'dd.mm.yyyy' | translate}}</mat-hint>
          @if (dialogForm.controls['date'].hasError('invalidDate')) {
            <mat-error>invalid date</mat-error>
          }
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label> {{'taskTemplates.time' | translate}}</mat-label>
          <input matInput type="time" formControlName="time">
        </mat-form-field>
      </div>
    }
  </form>
</section>
</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancelEdit();">{{'cancel' | translate}}</button>
  @if (contentUserRights_update) {
    <button mat-button class="orange-button" (click)="onSaveEdit();" [disabled]="!dialogForm.valid">{{'save' | translate}}</button>
  }
</mat-dialog-actions>
